/**
 *
 * @param {String} title
 *
 * @return {{el: HTMLParagraphElement, height: Number}}
 */
export default function generateRoutePdfTitle(title) {
  const el = document.createElement('p')
  el.style.fontSize = '24px';
  el.style.width = '719px';
  el.style.fontFamily = 'sans-serif';
  el.innerText = title;

  document.body.appendChild(el)
  const height = el.clientHeight
  el.remove()

  return {
    el,
    height
  };
}